import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook'
import { InvoiceIcon } from '../../ui/icons/invoiceIcon'
import { PlusIcon } from '../../ui/icons/plusIcon'
import { LayoutComponent } from '../../ui/layout'
import { BillowButton } from '../../ui/molecules/billowButton'
import { Pagination } from '../../ui/organisms/pagination'
import { MenuItems } from '../../ui/organisms/sidebar/dto'
import { InvoiceAmountList } from './list'
import { NewInvoiceAmountModal } from './newInvoiceAmountModal'
import { findAllInvoiceAmount, setInvoiceAmountFilterPage, setOpenNewInvoiceAmountModal } from './slice'

export default function InvoiceAmount() {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const invoiceAmountState = useAppSelector(state => state.invoiceAmount)
    const authState = useAppSelector(state => state.auth)

    useEffect(() => {
        dispatch(findAllInvoiceAmount({ ...invoiceAmountState.invoiceAmountFilters, page: invoiceAmountState.invoiceAmountFilters.page }))
    }, [invoiceAmountState.invoiceAmountFilters.page])

    return (
        <LayoutComponent
            menuItem={MenuItems.INVOICEAMOUNT}
            headingLabel={'Gestione costi mensili Cloud'}
            headingButtons={
                [
                    <BillowButton
                        icon={<PlusIcon size={'20'} color={'white'} />}
                        onClick={() => dispatch(setOpenNewInvoiceAmountModal(true))}
                        iconPosition={'left'}
                        variant={'solid'}
                        label='Inserisci costo mensile'
                    />
                ]
            }
            breadcrumbItems={['Gestione costi Cloud']}
            breadcrumbIcon={<InvoiceIcon size={'20'} color={'#6237FB'} />}
        >
            <InvoiceAmountList />
            {
                invoiceAmountState.findAllInvoiceAmountResponse !== undefined &&
                invoiceAmountState.findAllInvoiceAmountResponse.invoice_amounts.length > 0 &&
                <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
                    <Pagination
                        pages={invoiceAmountState.findAllInvoiceAmountResponse.totalPage || 1}
                        currentPage={invoiceAmountState.findAllInvoiceAmountResponse.page}
                        setPage={(page) => dispatch(setInvoiceAmountFilterPage(page))}
                    />
                </div>
            }
            <NewInvoiceAmountModal />
        </LayoutComponent>
    )
}
